import React from "react";
import { withRouter } from 'react-router';
import { connect } from "react-redux";
import {Redirect} from 'react-router-dom'
import {setLogin} from '../redux/actions'

import jwt_decode from 'jwt-decode'
import api from './axiosApi'

export const validateLogin = WrappedComponent => {
    const Validate = class extends React.Component {
        constructor(props) {
            super(props)
            this.state = {
                level:true
            }
        }
        async componentDidMount() {
            const {pathname} = this.props.history.location
            const localToken = window.sessionStorage.getItem('jwtuser')|| localStorage.getItem('jwtuser')
        
            const cookieToken = jwt_decode(localToken)
            const resp = await api.get(`/user/isAdmin?level=${cookieToken.user.level}&id=${cookieToken.user._id}`)
            this.setState({level: resp.data.data})
        }
        render() {
            
            const localToken = window.sessionStorage.getItem('jwtuser')|| localStorage.getItem('jwtuser')
            const cookieToken = localToken || this.props.token
            //debugger
            const token = this.props.token;
            if(!token) {
                this.props.setLogin(cookieToken)
            }
            const {pathname} = this.props.history.location 
            if(!this.state.level) {
                return<Redirect from="*" to="/" />
            }
            const isAllow = !!cookieToken && cookieToken !== ''
            if(!isAllow){
                return<Redirect from="*" to="/login" />
            }
            const newProps = {...this.props, token: cookieToken}
            //debugger
            return <WrappedComponent {...newProps}/>
        }
    }
    const mapDispatchToProps = dispatch => (
        {
            setLogin: value =>dispatch(setLogin(value)),
        })
    
    return withRouter(connect(state=>({token: state.user.token}), mapDispatchToProps)(Validate))
}